import { useState } from 'react';
import Modal from '../../components/common/Modal';
import { extrairMensagemErro } from '../../components/common/ErroCarregamento';
import { PERFIL_OPCOES } from '../../utils/webhookOpcoes';

export default function UsuarioForm({ usuario, perfilAtual, onClose, onSalvar }) {
  const [form, setForm] = useState({
    nome: usuario?.nome || '',
    email: usuario?.email || '',
    perfil: usuario?.perfil || 'consulta',
    ativo: usuario?.ativo ?? true,
    senha: '',
  });
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const alterar = (campo, valor) => setForm((atual) => ({ ...atual, [campo]: valor }));

  const enviar = async (e) => {
    e.preventDefault();
    setErro('');
    setSalvando(true);
    try {
      // na edição o e-mail e a senha não vão junto: senha tem endpoint próprio (reset) e o
      // e-mail é a identidade de login
      await onSalvar(
        usuario
          ? { nome: form.nome, perfil: form.perfil, ativo: form.ativo }
          : { nome: form.nome, email: form.email, perfil: form.perfil, senha: form.senha }
      );
      onClose();
    } catch (err) {
      setErro(extrairMensagemErro(err, 'Não foi possível salvar o usuário.'));
    } finally {
      setSalvando(false);
    }
  };

  const opcoes = PERFIL_OPCOES.filter((p) => p.value !== 'admin' || perfilAtual === 'admin');

  return (
    <Modal titulo={usuario ? `Editar ${usuario.nome}` : 'Novo usuário'} onClose={onClose}>
      <form onSubmit={enviar}>
        <div className="mb-3">
          <label className="wh-label">Nome *</label>
          <input className="wh-input" value={form.nome} onChange={(e) => alterar('nome', e.target.value)} required autoFocus />
        </div>

        {!usuario && (
          <>
            <div className="mb-3">
              <label className="wh-label">E-mail *</label>
              <input
                type="email"
                className="wh-input"
                value={form.email}
                onChange={(e) => alterar('email', e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="wh-label">Senha inicial *</label>
              <input
                type="password"
                className="wh-input"
                value={form.senha}
                onChange={(e) => alterar('senha', e.target.value)}
                minLength={8}
                required
              />
              <div className="wh-hint">Mínimo de 8 caracteres.</div>
            </div>
          </>
        )}

        <div className="mb-3">
          <label className="wh-label">Perfil *</label>
          <select className="wh-select" value={form.perfil} onChange={(e) => alterar('perfil', e.target.value)}>
            {opcoes.map((p) => (
              <option key={p.value} value={p.value}>
                {p.label}
              </option>
            ))}
          </select>
          <div className="wh-hint">{PERFIL_OPCOES.find((p) => p.value === form.perfil)?.descricao}</div>
        </div>

        {usuario && (
          <div className="mb-3">
            <label className="wh-label">Situação</label>
            <select className="wh-select" value={form.ativo ? '1' : '0'} onChange={(e) => alterar('ativo', e.target.value === '1')}>
              <option value="1">Ativo</option>
              <option value="0">Inativo</option>
            </select>
          </div>
        )}

        {erro && (
          <div className="alert alert-danger py-2 px-3" style={{ fontSize: 13 }}>
            {erro}
          </div>
        )}

        <div className="d-flex justify-content-end gap-2">
          <button type="button" className="wh-btn wh-btn-outline" onClick={onClose} disabled={salvando}>
            Cancelar
          </button>
          <button type="submit" className="wh-btn wh-btn-primary" disabled={salvando}>
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
